import cn from 'classnames';
import React, { useState } from 'react';
import { InstanceProps, create } from 'react-modal-promise';

import { ButtonV3 } from 'components/ComponentV2';
import Modal from 'components/Modal';

import { MatchesFrequency } from 'components/candidate/MatchesFrequency/MatchesFrequency.component';
import { useCandidate } from 'hooks/useCandidate';
import { useAuth } from 'lib/providers/AuthProvider';
import styles from './MatchesNotificationModal.module.scss';

const ModalInstance: React.FC<InstanceProps<number>> = ({
  isOpen,
  onReject,
  onResolve,
}) => {
  const { updateCandidateEmailMatchesFrequency } = useCandidate();
  const { candidate } = useAuth();
  const [frequency, setFrequency] = useState(
    candidate?.matches_email_frequency || 'never'
  );

  const handleFrequencyChange = (frequency: string) => {
    setFrequency(frequency);
  };
  const handleDoneClick = async () => {
    await updateCandidateEmailMatchesFrequency({
      matchesFrequency: frequency,
    });
    onResolve(1);
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onReject}
      contentClassName={cn(styles.container, {})}
      className={styles.modal}
    >
      <MatchesFrequency
        className={styles.containerModal}
        isModal={true}
        onFrequencyChange={handleFrequencyChange}
        closeModal={onReject}
      />

      <div className={styles.footer}>
        <ButtonV3
          size="medium"
          onClick={handleDoneClick}
          className={styles.button}
        >
          Done
        </ButtonV3>
      </div>
    </Modal>
  );
};

export const MatchesNotificationModal = create(ModalInstance);
